module.exports = __webpack_public_path__ + "img/banner.c6ed4f70.png";